const counter = () => {
  const items = document.querySelectorAll('.block-counter__number');
  if (!items.length) return;

  items.forEach(el => {
    const target = parseFloat(el.dataset.target);
    const isFloat = !Number.isInteger(target);
    const obj = { value: 0 };

    ScrollTrigger.create({
      trigger: el,
      start: 'top 85%',
      once: true,
      onEnter: () => {
        gsap.to(obj, {
          value: target,
          duration: 5,
          ease: 'power2.out',
          onUpdate: () => {
            el.textContent = isFloat
              ? obj.value.toFixed(1)
              : Math.round(obj.value).toLocaleString('it-IT');
          },
        });
      },
    });
  });
};

export default counter;
